document.addEventListener('DOMContentLoaded', () => {
            lucide.createIcons();

            const state = {
                cart: [],
                selectedColor: 'Black',
                products: {
                    headphones: { id: 1, name: 'Sony WH-1000XM5 Headphones', price: 399.99 },
                    upsell: { id: 2, name: 'Hard-Shell Travel Case', price: 29.99, image: 'https://placehold.co/80x80/e0e7ff/4a4a4a?text=Case' }
                }
            };
            
            // Element Selectors
            const addToCartBtn = document.getElementById('add-to-cart-btn');
            const slideOutCart = document.getElementById('slide-out-cart');
            const closeCartBtn = document.getElementById('close-cart-btn');
            const cartOverlay = document.getElementById('cart-overlay');
            const cartItemsContainer = document.getElementById('cart-items');
            const subtotalAmount = document.getElementById('subtotal-amount');
            const headerCartCount = document.getElementById('header-cart-count');
            const headerCartButton = document.getElementById('header-cart-button');
            const emptyCartMessage = document.getElementById('empty-cart-message');
            const upsellSection = document.getElementById('upsell-section');
            const addUpsellBtn = document.getElementById('add-upsell-btn');
            const colorSelector = document.getElementById('color-selector');
            const selectedColorText = document.getElementById('selected-color-text');
            const mainProductImage = document.getElementById('main-product-image');
            const productThumbnails = document.querySelectorAll('.product-thumbnail');
            const cartBnplMessaging = document.getElementById('cart-bnpl-messaging');
            const bnplAmount = document.getElementById('bnpl-amount');

            
            const openCart = () => {
                slideOutCart.classList.add('open');
                cartOverlay.classList.remove('hidden');
                document.body.style.overflow = 'hidden';
            };

            const closeCart = () => {
                slideOutCart.classList.remove('open');
                cartOverlay.classList.add('hidden');
                document.body.style.overflow = '';
            };
            
            const updateColorSelection = (color, image, swatchElement) => {
                state.selectedColor = color;
                selectedColorText.textContent = color;
                mainProductImage.src = image;
                mainProductImage.alt = `Sony WH-1000XM5 Headphones in ${color}`;
                document.querySelectorAll('.color-swatch').forEach(sw => sw.classList.remove('selected'));
                swatchElement.classList.add('selected');
                productThumbnails.forEach(thumb => {
                    const parent = thumb.parentElement;
                    if (thumb.dataset.color === color) {
                        parent.classList.add('border-blue-500');
                        parent.classList.remove('border-transparent');
                    } else {
                        parent.classList.remove('border-blue-500');
                        parent.classList.add('border-transparent');
                    }
                });
            };
            
            const renderCart = () => {
                cartItemsContainer.innerHTML = '';
                if (state.cart.length === 0) {
                    emptyCartMessage.classList.remove('hidden');
                    upsellSection.classList.add('hidden');
                } else {
                    emptyCartMessage.classList.add('hidden');
                    const hasHeadphones = state.cart.some(item => item.id === state.products.headphones.id);
                    const hasUpsell = state.cart.some(item => item.id === state.products.upsell.id);
                    if (hasHeadphones && !hasUpsell) {
                         upsellSection.classList.remove('hidden');
                    } else {
                         upsellSection.classList.add('hidden');
                    }
                }
                state.cart.forEach(item => {
                    const variantInfo = item.id === state.products.headphones.id ? `<p class="text-xs text-gray-500">Color: ${item.variant}</p>` : '';
                    const itemElement = document.createElement('div');
                    itemElement.className = 'flex items-center space-x-4';
                    itemElement.innerHTML = `
                        <img src="${item.image}" alt="${item.name}" class="w-20 h-20 rounded-md object-cover">
                        <div class="flex-grow">
                            <p class="font-medium text-sm text-gray-800">${item.name}</p>
                            ${variantInfo}
                            <p class="text-gray-600 font-bold mt-1">$${item.price.toFixed(2)}</p>
                        </div>
                        <div class="flex flex-col items-center">
                             <div class="flex items-center border border-gray-200 rounded-md">
                                <button class="quantity-change px-2 py-1 text-gray-600" data-id="${item.id}" data-variant="${item.variant}" data-change="-1">-</button>
                                <span class="px-2 text-sm">${item.quantity}</span>
                                <button class="quantity-change px-2 py-1 text-gray-600" data-id="${item.id}" data-variant="${item.variant}" data-change="1">+</button>
                            </div>
                            <button class="remove-item text-xs text-red-500 hover:underline mt-2" data-id="${item.id}" data-variant="${item.variant}">Remove</button>
                        </div>
                    `;
                    cartItemsContainer.appendChild(itemElement);
                });
                updateTotals();
            };

            const updateTotals = () => {
                const subtotal = state.cart.reduce((acc, item) => acc + (item.price * item.quantity), 0);
                const totalQuantity = state.cart.reduce((acc, item) => acc + item.quantity, 0);
                subtotalAmount.textContent = `$${subtotal.toFixed(2)}`;
                headerCartCount.textContent = totalQuantity;
                
                if(totalQuantity > 0) {
                    headerCartCount.classList.remove('hidden');
                } else {
                    headerCartCount.classList.add('hidden');
                }

                if (subtotal > 0) {
                    bnplAmount.textContent = `$${(subtotal / 4).toFixed(2)}`;
                    cartBnplMessaging.classList.remove('hidden');
                } else {
                    cartBnplMessaging.classList.add('hidden');
                }
            };

            const addItemToCart = (item, variant = null, image) => {
                const existingItem = state.cart.find(cartItem => cartItem.id === item.id && cartItem.variant === variant);
                if (existingItem) {
                    existingItem.quantity++;
                } else {
                    state.cart.push({ ...item, quantity: 1, variant, image });
                }
                renderCart();
            };
            
            const changeItemQuantity = (id, variant, change) => {
                 const item = state.cart.find(cartItem => cartItem.id === id && cartItem.variant === variant);
                 if (item) {
                     item.quantity += change;
                     if (item.quantity <= 0) {
                         removeItemFromCart(id, variant);
                     } else {
                        renderCart();
                     }
                 }
            };
            
            const removeItemFromCart = (id, variant) => {
                state.cart = state.cart.filter(item => !(item.id === id && item.variant === variant));
                renderCart();
            };

            addToCartBtn.addEventListener('click', () => {
                const product = state.products.headphones;
                const image = document.querySelector(`.color-swatch.selected`).dataset.image;
                addItemToCart(product, state.selectedColor, image);
                openCart();
            });
            
            addUpsellBtn.addEventListener('click', () => {
                addItemToCart(state.products.upsell, null, state.products.upsell.image);
                addUpsellBtn.textContent = 'Added!';
                addUpsellBtn.disabled = true;
                setTimeout(() => {
                   upsellSection.classList.add('hidden');
                }, 1000);
            });

            closeCartBtn.addEventListener('click', closeCart);
            cartOverlay.addEventListener('click', closeCart);
            headerCartButton.addEventListener('click', openCart);
            
            colorSelector.addEventListener('click', (e) => {
                const swatch = e.target.closest('.color-swatch');
                if(swatch) {
                    updateColorSelection(swatch.dataset.color, swatch.dataset.image, swatch);
                }
            });

            productThumbnails.forEach(thumb => {
                thumb.addEventListener('click', () => {
                    const swatch = document.querySelector(`.color-swatch[data-color="${thumb.dataset.color}"]`);
                    if(swatch) {
                       updateColorSelection(thumb.dataset.color, thumb.dataset.image, swatch);
                    }
                });
            });

            cartItemsContainer.addEventListener('click', (e) => {
                if (e.target.closest('.quantity-change')) {
                    const button = e.target.closest('.quantity-change');
                    const { id, variant, change } = button.dataset;
                    changeItemQuantity(parseInt(id), variant, parseInt(change));
                }
                if (e.target.closest('.remove-item')) {
                    const button = e.target.closest('.remove-item');
                    const { id, variant } = button.dataset;
                    removeItemFromCart(parseInt(id), variant);
                }
            });
            
            document.querySelectorAll('.accordion-header').forEach(header => {
                header.addEventListener('click', () => {
                    const content = header.nextElementSibling;
                    const icon = header.querySelector('svg'); // Use 'svg' as lucide replaces 'i' tags
                    if (content && icon) {
                        if (content.style.maxHeight) {
                            content.style.maxHeight = null;
                            icon.style.transform = 'rotate(0deg)';
                        } else {
                            document.querySelectorAll('.accordion-content').forEach(c => c.style.maxHeight = null);
                            document.querySelectorAll('.accordion-header svg').forEach(i => i.style.transform = 'rotate(0deg)');
                            content.style.maxHeight = content.scrollHeight + "px";
                            icon.style.transform = 'rotate(180deg)';
                        }
                    }
                });
            });
            
            renderCart();
        });